export default {
  loadingError: {
    title: 'Erreur',
    message: 'Désolé, l\'application n\'a pu être chargée.',
    retryButton: 'Réessayer',
  },
};
